// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordValidationErrorDto
 */
export interface IRecordValidationErrorDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordValidationErrorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecordValidationErrorDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IRecordValidationErrorDto
     */
    field_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IRecordValidationErrorDto
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecordValidationErrorDto
     */
    validation_error_type?: IRecordValidationErrorDtoValidationErrorTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRecordValidationErrorDtoValidationErrorTypeEnum {
    VALIDATION_NOT_EXIST = 'VALIDATION_NOT_EXIST',
    INCORRECT_VALUE = 'INCORRECT_VALUE',
    VALUE_IS_EMPTY = 'VALUE_IS_EMPTY'
}


/**
 * Check if a given object implements the IRecordValidationErrorDto interface.
 */
export function instanceOfIRecordValidationErrorDto(value: object): value is IRecordValidationErrorDto {
    return true;
}

export function IRecordValidationErrorDtoFromJSON(json: any): IRecordValidationErrorDto {
    return IRecordValidationErrorDtoFromJSONTyped(json, false);
}

export function IRecordValidationErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordValidationErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'record_id': json['record_id'] == null ? undefined : json['record_id'],
        'validation_error_type': json['validation_error_type'] == null ? undefined : json['validation_error_type'],
    };
}

export function IRecordValidationErrorDtoToJSON(json: any): IRecordValidationErrorDto {
    return IRecordValidationErrorDtoToJSONTyped(json, false);
}

export function IRecordValidationErrorDtoToJSONTyped(value?: IRecordValidationErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_code': value['plan_code'],
        'field_name': value['field_name'],
        'record_id': value['record_id'],
        'validation_error_type': value['validation_error_type'],
    };
}

